var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"!transition-all !duration-300",class:{
    '!text-[#C2C2C2] !bg-[#F4F4F4] !border-[#E2E2E2]': _vm.isDisabled
  },attrs:{"variant":_vm.isDisabled ? 'light' : 'primary',"disabled":_vm.isDisabled || _vm.loading},on:{"click":function($event){return _vm.$emit('cancel')}}},[(_vm.loading)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),_vm._v(" Batalkan Order ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }